module.exports = __webpack_public_path__ + "img/user_profile_5.353bd12e.png";